module.exports = __webpack_public_path__ + "static/img/domain.c0302947.png";